import React, { useState } from "react";
import "./HomeAbout.scss";
import Heading from "../Heading/Heading";
import Button from "../Button/Button";
import { Link } from "react-router-dom";

export default function About() {
  const [textActive, setTextActive] = useState<"recruiters" | "clients">(
    "recruiters"
  );

  return (
    <section className="homepage__about">
      <Heading content="About Zea" />
      <div className="about__content">
        <section className="about__left">
          {textActive === "recruiters" ? (
            <div className="about__texts about__texts--recruiters">
              <p className="about__text">
                Hi I'm Zea! I'm a full-stack web developer passionate about
                building high quality, purpose-driven digital experiences. I
                specialize in{" "}
                <span className="about__text--accent">JavaScript</span>,{" "}
                <span className="about__text--accent">React</span>,{" "}
                <span className="about__text--accent">Node.js</span> and{" "}
                <span className="about__text--accent">Typescript</span>, with a
                skill set that spans from front-end design to back-end
                development. My approach combines a deep technical proficiency
                with a commitment to creating intuitive, reliable products
                designed to highlight what makes each client unique.
              </p>
              <p className="about__text">
                With a background in music performance, I developed the
                discipline, adaptability, and creativity that I bring to every
                project. Whether it's helping churches or small businesses get a
                unique online presence, I focus on delivering solutions that are
                not only high quality, but also true to the client's style and
                culture. I take the time to understand each client's goals and
                values, ensuring their site feels authentic and connects with
                their audience.
              </p>
              <p className="about__text">
                I'm highly collaborative, communicative, and proactive about
                problem-solving. I strive to create well-documented,
                maintainable code and work effectively with teams to meet
                project goals. My ideal role is one where I can grow alongside a
                talented team, learn from experienced developers, and contribute
                meaningfully to the company's mission.
              </p>
            </div>
          ) : (
            <div className="about__texts about__texts--clients">
              <p className="about__text">
                Hi, I’m Zea! I’m a web developer passionate about helping
                clients like you bring their unique vision to life through
                high-quality, purpose-driven digital experiences. I specialize
                in JavaScript, React, Node.js, and TypeScript, covering
                everything from front-end design to back-end development. My
                goal is to deliver a website that’s not only visually appealing
                but also reliable, intuitive, and true to your brand.
              </p>
              <p className="about__text">
                With a background in music performance, I developed the
                discipline, creativity, and adaptability that now guide my work
                in web development. I take the time to fully understand your
                style, goals, and values, ensuring your site feels authentic and
                connects meaningfully with your audience. Whether I’m working
                with churches, small businesses, or startups, I’m committed to
                creating something that’s uniquely yours.
              </p>
              <p className="about__text">
                Throughout the process, I’m highly collaborative, communicative,
                and responsive—ready to adjust and refine as needed to make sure
                the end product meets your expectations. I focus on building
                well-documented, maintainable code that sets you up for success
                now and down the road. I look forward to building something
                together that you’ll be proud to share with the world.
              </p>
            </div>
          )}
          <div className="about__sections">
            <button
              className={`about__recruiters ${
                textActive === "recruiters" ? "about__recruiters--active" : ""
              }`}
              onClick={() => setTextActive("recruiters")}
            >
              For recruiters
            </button>
            <button
              className={`about__clients ${
                textActive === "clients" ? "about__clients--active" : ""
              }`}
              onClick={() => setTextActive("clients")}
            >
              For clients
            </button>
          </div>
        </section>
        <section className="about__right">
          <h4 className="about__title">Tech Services</h4>
          <ul className="about__services">
            <li className="about__service">Consultation</li>
            <li className="about__service">Web Design</li>
            <li className="about__service">Web Development</li>
            <li className="about__service">Web Hosting</li>
            <li className="about__service">Web Maintenance</li>
          </ul>
          <div className="about__buttons">
            <a
              href="/ZunigaResume.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                content="My Resume"
                classtitle="button button--primary button__about--1"
              />
            </a>
            <Link to="/services">
              <Button
                content="Services"
                classtitle="button button--secondary button__about--2"
              />
            </Link>
          </div>
        </section>
      </div>
    </section>
  );
}
